import { render, staticRenderFns } from "./ColorOps.vue?vue&type=template&id=0b07789e&scoped=true&"
import script from "./ColorOps.vue?vue&type=script&lang=js&"
export * from "./ColorOps.vue?vue&type=script&lang=js&"
import style0 from "./ColorOps.vue?vue&type=style&index=0&id=0b07789e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b07789e",
  null
  
)

export default component.exports